module.exports = require("@adobe/aem-spa-component-mapping");